const TIPOS_FILTER_MULTIPLE = [
  { NombreTag: 'metadatos', Required: ['campo', 'valor'] }
]

export {
  TIPOS_FILTER_MULTIPLE
}
